export default __webpack_public_path__ + "static/goteborg-e2a17078441076f2454cd8e1a1dac678.jpg";